/* eslint no-multi-spaces: 0 */
import 'es6-promise/auto'

global.config = global.config || {
  enableThemes: true
}

// Vue
import Vue           from 'vue'
import App           from './App'
import { EventBus }  from '@/event-bus'
import router        from '@/router'
import {store}       from '@/components/store'
import {i18n}        from '@/lang/lang'
import AsyncComputed from 'vue-async-computed'
import Vuelidate     from 'vuelidate'

// Core
import API                from '@/core/api'
import CoreComponents     from '@/core/components'
import NotificationPlugin from '@/core/components/mdNotifications/install'
import Charts             from '@/core/charts'
import VueCountryCode     from 'vue-country-code-select'
import VTooltip           from 'v-tooltip'

// Value objects
import ValueObjects       from '@/core/value-objects'

// Libraries
import 'bootstrap/dist/css/bootstrap.css'
import '@/assets/sass/main.scss'

Vue.config.productionTip = false
Vue.config.warnHandler = (msg, vm, trace) => {
  if (~msg.indexOf('Error compiling template')) EventBus.$emit('warning', { msg })
  else console.warn(msg, trace)
}

// Install
Vue.use(AsyncComputed)
Vue.use(Vuelidate)
Vue.use(API)
Vue.use(CoreComponents)
Vue.use(NotificationPlugin)
Vue.use(Charts)
Vue.use(VueCountryCode)
Vue.use(VTooltip)
Vue.use(ValueObjects)

// Boot
App.boot({Vue, App, router, store, i18n, API, Charts})

// Version
global.version = version



// WEBPACK FOOTER //
// ./src/main.js